export default __webpack_public_path__ + "static/media/Asteroids.4332f72d.png";